import BodySnippet from './BodySnippet';
import HeadSnippet from './HeadSnippet';
import {
    clearGtmUserData,
    reportGtmUserData,
} from './userData';
import {
    dataLayer,
} from './utils';

const gtm = {
    dataLayer,
};
export {
    BodySnippet,
    HeadSnippet,
    clearGtmUserData,
    gtm,
    reportGtmUserData,
};
